import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { PushNotificationService } from '../../services/push-notification.service'

@Component({
    selector: 'app-enable-push-notifications-dialog',
    templateUrl: './enable-push-notifications-dialog.component.html',
    styleUrls: ['./enable-push-notifications-dialog.component.css'],
})
export class EnablePushNotificationsDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EnablePushNotificationsDialogComponent>,

        private pushNotificationService: PushNotificationService,
    ) {}

    async enable() {
        await this.pushNotificationService.requestPermissionAndSubscribe()
        this.dialogRef.close('enabled')
    }

    notNow() {
        this.dialogRef.close('declined')
    }
}
